/** @format */

import { UIRow, UICol, UIText } from "@rstore-react-packages/template-ui";
import { Button, Form } from "antd";
import React from "react";
import { useDispatch } from "react-redux";
import { actionMassivePeopleActivationRequest } from "../../../../redux-modules/actions/actionsGeneral";
import { useLanguage } from "../../../../redux-modules/hooks/useLanguage";
import StyledModal from "../../../ui/Modal";

/** @format */
interface Props {
  visible: boolean;
  handleOk?: () => void;
  handleCancel?: () => void;
  people: number[];
}
const ModalChangeActivation = ({
  visible = false,
  handleCancel,
  handleOk,
  people,
}: Props): JSX.Element => {
  const l = useLanguage();
  const [form] = Form.useForm();
  const dispatch = useDispatch();

  const handleFinish = (form): void => {
    dispatch(
      actionMassivePeopleActivationRequest({
        users_ids: people,
        action: "activation",
      }),
    );
    //@ts-ignore
    handleOk && handleOk();
  };

  const handleReturn = (): void => {
    handleCancel && handleCancel();
  };

  return (
    <StyledModal
      title={l("sendActivationMail")}
      visible={visible}
      onCancel={handleCancel}
      footer={[
        <Button key="back" onClick={handleReturn}>
          Return
        </Button>,
        <Button key="submit" onClick={(): void => form.submit()}>
          Submit
        </Button>,
      ]}
    >
      <UIRow>
        <UICol xs={24}>
          <Form form={form} name="edit-people-activation" layout="inline" onFinish={handleFinish}>
            <UIText>{"You are sending activation email to " + people.length + " people."}</UIText>
          </Form>
        </UICol>
      </UIRow>
    </StyledModal>
  );
};

export default ModalChangeActivation;
